import createStore from "./utils/create-store";

interface IORefreshTokenStore {
    isTokenRefreshed: boolean;
    isTokenRefreshing: boolean;
    setTokenRefreshing: (status: boolean) => void;
    setTokenRefreshed: (status: boolean) => void
}

export const useRefreshTokenStore = createStore<IORefreshTokenStore>((set) => ({
    isTokenRefreshed: false,
    isTokenRefreshing: false,
    setTokenRefreshing: (status: boolean) =>
        set((state) => ({ isTokenRefreshing: status })),
    setTokenRefreshed: (status: boolean) =>
        set((state) => ({ isTokenRefreshed: status })),
}));
